import { UrlParams, UrlSegments } from '@provision/portal-routes';
import { CustomViewEntity } from 'src/graphql/entities/custom-view';

import { useRouteParams } from 'src/utils/routing';
import { capitalizeString } from 'src/utils/strings';

export const useSelectedViewUrlContext = (entityName: CustomViewEntity) => {
  const { recordId } = useRouteParams(UrlParams.recordId);
  const { customViewId: selectedCustomViewId } = useRouteParams(UrlParams.customViewId);
  const isStaticView = selectedCustomViewId === UrlSegments.view.all;
  const viewId = isStaticView ? getAllViewId(entityName) : selectedCustomViewId;

  return {
    recordId,
    selectedCustomViewId,
    isStaticView,
    viewId,
  };
};

export function getAllViewId(entityName: string) {
  return `all${capitalizeString(entityName)}`;
}
